import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import "../Header/LinkAnimation.css";
import { useLanguage } from "LanguageContext";

const FooterLinks = ({ data }) => {
  const { selectedLanguage } = useLanguage();

  return (
    <Box>
      <Box display="flex" flexDirection="column" color="white">
        <Box marginTop="30px">
          {data?.map((item) => {
            if (item?.attributes?.active)
              return (
                <Box
                  display="flex"
                  flexDirection="column"
                  key={item?.attributes?.text}
                  onClick={() => {window.location.href = `/${selectedLanguage}/${item?.attributes?.link}`;}}
                  className="link"
                  cursor="pointer"
                >
                  <Text fontSize="13px" fontWeight="300px">
                    {item?.attributes?.text}
                  </Text>
                </Box>
              );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default FooterLinks;
